import { html as o, when as t } from "@microsoft/fast-element";
const C = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.25 2.25C10.0074 2.25 9 3.25736 9 4.5V6C9 7.24264 10.0074 8.25 11.25 8.25H12.75C13.9926 8.25 15 7.24264 15 6V4.5C15 3.25736 13.9926 2.25 12.75 2.25H11.25Z"
      fill="currentColor"
    />
    <path
      d="M4.25 9.25C3.00736 9.25 2 10.2574 2 11.5V13C2 14.2426 3.00736 15.25 4.25 15.25H5.75C6.99264 15.25 8 14.2426 8 13V11.5C8 10.2574 6.99264 9.25 5.75 9.25H4.25Z"
      fill="currentColor"
    />
    <path
      d="M18.25 9.25C17.0074 9.25 16 10.2574 16 11.5V13C16 14.2426 17.0074 15.25 18.25 15.25H19.75C20.9926 15.25 22 14.2426 22 13V11.5C22 10.2574 20.9926 9.25 19.75 9.25H18.25Z"
      fill="currentColor"
    />
    <path
      d="M11.25 9.25C10.0074 9.25 9 10.2574 9 11.5V13C9 14.2426 10.0074 15.25 11.25 15.25H12.75C13.9926 15.25 15 14.2426 15 13V11.5C15 10.2574 13.9926 9.25 12.75 9.25H11.25Z"
      fill="currentColor"
    />
    <path
      d="M4.25 16.25C3.00736 16.25 2 17.2574 2 18.5V20C2 21.2426 3.00736 22.25 4.25 22.25H5.75C6.99264 22.25 8 21.2426 8 20V18.5C8 17.2574 6.99264 16.25 5.75 16.25H4.25Z"
      fill="currentColor"
    />
    <path
      d="M18.25 16.25C17.0074 16.25 16 17.2574 16 18.5V20C16 21.2426 17.0074 22.25 18.25 22.25H19.75C20.9926 22.25 22 21.2426 22 20V18.5C22 17.2574 20.9926 16.25 19.75 16.25H18.25Z"
      fill="currentColor"
    />
    <path
      d="M11.25 16.25C10.0074 16.25 9 17.2574 9 18.5V20C9 21.2426 10.0074 22.25 11.25 22.25H12.75C13.9926 22.25 15 21.2426 15 20V18.5C15 17.2574 13.9926 16.25 12.75 16.25H11.25Z"
      fill="currentColor"
    />
    <path
      d="M4.25 2.25C3.00736 2.25 2 3.25736 2 4.5V6C2 7.24264 3.00736 8.25 4.25 8.25H5.75C6.99264 8.25 8 7.24264 8 6V4.5C8 3.25736 6.99264 2.25 5.75 2.25H4.25Z"
      fill="currentColor"
    />
    <path
      d="M18.25 2.25C17.0074 2.25 16 3.25736 16 4.5V6C16 7.24264 17.0074 8.25 18.25 8.25H19.75C20.9926 8.25 22 7.24264 22 6V4.5C22 3.25736 20.9926 2.25 19.75 2.25H18.25Z"
      fill="currentColor"
    />
  </svg>
`, e = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.75 11.5C2.75 10.6716 3.42157 10 4.25 10H5.75C6.57843 10 7.25 10.6716 7.25 11.5V13C7.25 13.8284 6.57843 14.5 5.75 14.5H4.25C3.42157 14.5 2.75 13.8284 2.75 13V11.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.75 11.5C16.75 10.6716 17.4216 10 18.25 10H19.75C20.5784 10 21.25 10.6716 21.25 11.5V13C21.25 13.8284 20.5784 14.5 19.75 14.5H18.25C17.4216 14.5 16.75 13.8284 16.75 13V11.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 11.5C9.75 10.6716 10.4216 10 11.25 10H12.75C13.5784 10 14.25 10.6716 14.25 11.5V13C14.25 13.8284 13.5784 14.5 12.75 14.5H11.25C10.4216 14.5 9.75 13.8284 9.75 13V11.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75 18.5C2.75 17.6716 3.42157 17 4.25 17H5.75C6.57843 17 7.25 17.6716 7.25 18.5V20C7.25 20.8284 6.57843 21.5 5.75 21.5H4.25C3.42157 21.5 2.75 20.8284 2.75 20V18.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.75 18.5C16.75 17.6716 17.4216 17 18.25 17H19.75C20.5784 17 21.25 17.6716 21.25 18.5V20C21.25 20.8284 20.5784 21.5 19.75 21.5H18.25C17.4216 21.5 16.75 20.8284 16.75 20V18.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 18.5C9.75 17.6716 10.4216 17 11.25 17H12.75C13.5784 17 14.25 17.6716 14.25 18.5V20C14.25 20.8284 13.5784 21.5 12.75 21.5H11.25C10.4216 21.5 9.75 20.8284 9.75 20V18.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 4.5C9.75 3.67157 10.4216 3 11.25 3H12.75C13.5784 3 14.25 3.67157 14.25 4.5V6C14.25 6.82843 13.5784 7.5 12.75 7.5H11.25C10.4216 7.5 9.75 6.82843 9.75 6V4.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75 4.5C2.75 3.67157 3.42157 3 4.25 3H5.75C6.57843 3 7.25 3.67157 7.25 4.5V6C7.25 6.82843 6.57843 7.5 5.75 7.5H4.25C3.42157 7.5 2.75 6.82843 2.75 6V4.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.75 4.5C16.75 3.67157 17.4216 3 18.25 3H19.75C20.5784 3 21.25 3.67157 21.25 4.5V6C21.25 6.82843 20.5784 7.5 19.75 7.5H18.25C17.4216 7.5 16.75 6.82843 16.75 6V4.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, n = o`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.58334 2C8.61685 2 7.83334 2.7835 7.83334 3.75V4.75C7.83334 5.7165 8.61685 6.5 9.58334 6.5H10.5833C11.5498 6.5 12.3333 5.7165 12.3333 4.75V3.75C12.3333 2.7835 11.5498 2 10.5833 2H9.58334Z"
      fill="currentColor"
    />
    <path
      d="M3.75 7.83325C2.7835 7.83325 2 8.61675 2 9.58325V10.5833C2 11.5498 2.7835 12.3333 3.75 12.3333H4.75C5.7165 12.3333 6.5 11.5498 6.5 10.5833V9.58325C6.5 8.61675 5.7165 7.83325 4.75 7.83325H3.75Z"
      fill="currentColor"
    />
    <path
      d="M15.4167 7.83325C14.4502 7.83325 13.6667 8.61675 13.6667 9.58325V10.5833C13.6667 11.5498 14.4502 12.3333 15.4167 12.3333H16.4167C17.3832 12.3333 18.1667 11.5498 18.1667 10.5833V9.58325C18.1667 8.61675 17.3832 7.83325 16.4167 7.83325H15.4167Z"
      fill="currentColor"
    />
    <path
      d="M9.58334 7.83325C8.61685 7.83325 7.83334 8.61675 7.83334 9.58325V10.5833C7.83334 11.5498 8.61685 12.3333 9.58334 12.3333H10.5833C11.5498 12.3333 12.3333 11.5498 12.3333 10.5833V9.58325C12.3333 8.61675 11.5498 7.83325 10.5833 7.83325H9.58334Z"
      fill="currentColor"
    />
    <path
      d="M3.75 13.6667C2.7835 13.6667 2 14.4502 2 15.4167V16.4167C2 17.3832 2.7835 18.1667 3.75 18.1667H4.75C5.7165 18.1667 6.5 17.3832 6.5 16.4167V15.4167C6.5 14.4502 5.7165 13.6667 4.75 13.6667H3.75Z"
      fill="currentColor"
    />
    <path
      d="M15.4167 13.6667C14.4502 13.6667 13.6667 14.4502 13.6667 15.4167V16.4167C13.6667 17.3832 14.4502 18.1667 15.4167 18.1667H16.4167C17.3832 18.1667 18.1667 17.3832 18.1667 16.4167V15.4167C18.1667 14.4502 17.3832 13.6667 16.4167 13.6667H15.4167Z"
      fill="currentColor"
    />
    <path
      d="M9.58334 13.6667C8.61685 13.6667 7.83334 14.4502 7.83334 15.4167V16.4167C7.83334 17.3832 8.61685 18.1667 9.58334 18.1667H10.5833C11.5498 18.1667 12.3333 17.3832 12.3333 16.4167V15.4167C12.3333 14.4502 11.5498 13.6667 10.5833 13.6667H9.58334Z"
      fill="currentColor"
    />
    <path
      d="M3.75 2C2.7835 2 2 2.7835 2 3.75V4.75C2 5.7165 2.7835 6.5 3.75 6.5H4.75C5.7165 6.5 6.5 5.7165 6.5 4.75V3.75C6.5 2.7835 5.7165 2 4.75 2H3.75Z"
      fill="currentColor"
    />
    <path
      d="M15.4167 2C14.4502 2 13.6667 2.7835 13.6667 3.75V4.75C13.6667 5.7165 14.4502 6.5 15.4167 6.5H16.4167C17.3832 6.5 18.1667 5.7165 18.1667 4.75V3.75C18.1667 2.7835 17.3832 2 16.4167 2H15.4167Z"
      fill="currentColor"
    />
  </svg>
`, l = o`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 7.46675C2 7.02492 2.35817 6.66675 2.8 6.66675H3.6C4.04183 6.66675 4.4 7.02492 4.4 7.46675V8.26675C4.4 8.70858 4.04183 9.06675 3.6 9.06675H2.8C2.35817 9.06675 2 8.70858 2 8.26675V7.46675Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 7.46675C11.3333 7.02492 11.6915 6.66675 12.1333 6.66675H12.9333C13.3752 6.66675 13.7333 7.02492 13.7333 7.46675V8.26675C13.7333 8.70858 13.3752 9.06675 12.9333 9.06675H12.1333C11.6915 9.06675 11.3333 8.70858 11.3333 8.26675V7.46675Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66669 7.46675C6.66669 7.02492 7.02486 6.66675 7.46669 6.66675H8.26669C8.70851 6.66675 9.06669 7.02492 9.06669 7.46675V8.26675C9.06669 8.70858 8.70851 9.06675 8.26669 9.06675H7.46669C7.02486 9.06675 6.66669 8.70858 6.66669 8.26675V7.46675Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 12.1335C2 11.6917 2.35817 11.3335 2.8 11.3335H3.6C4.04183 11.3335 4.4 11.6917 4.4 12.1335V12.9335C4.4 13.3753 4.04183 13.7335 3.6 13.7335H2.8C2.35817 13.7335 2 13.3753 2 12.9335V12.1335Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 12.1335C11.3333 11.6917 11.6915 11.3335 12.1333 11.3335H12.9333C13.3752 11.3335 13.7333 11.6917 13.7333 12.1335V12.9335C13.7333 13.3753 13.3752 13.7335 12.9333 13.7335H12.1333C11.6915 13.7335 11.3333 13.3753 11.3333 12.9335V12.1335Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66669 12.1335C6.66669 11.6917 7.02486 11.3335 7.46669 11.3335H8.26669C8.70851 11.3335 9.06669 11.6917 9.06669 12.1335V12.9335C9.06669 13.3753 8.70851 13.7335 8.26669 13.7335H7.46669C7.02486 13.7335 6.66669 13.3753 6.66669 12.9335V12.1335Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66669 2.8C6.66669 2.35817 7.02486 2 7.46669 2H8.26669C8.70851 2 9.06669 2.35817 9.06669 2.8V3.6C9.06669 4.04183 8.70851 4.4 8.26669 4.4H7.46669C7.02486 4.4 6.66669 4.04183 6.66669 3.6V2.8Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 2.8C2 2.35817 2.35817 2 2.8 2H3.6C4.04183 2 4.4 2.35817 4.4 2.8V3.6C4.4 4.04183 4.04183 4.4 3.6 4.4H2.8C2.35817 4.4 2 4.04183 2 3.6V2.8Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 2.8C11.3333 2.35817 11.6915 2 12.1333 2H12.9333C13.3752 2 13.7333 2.35817 13.7333 2.8V3.6C13.7333 4.04183 13.3752 4.4 12.9333 4.4H12.1333C11.6915 4.4 11.3333 4.04183 11.3333 3.6V2.8Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, s = o`
  ${t((r) => r._type === "outline", e)}
  ${t((r) => r._type === "solid", C)}
  ${t((r) => r._type === "mini", n)}
  ${t((r) => r._type === "micro", l)}
`;
export {
  s as bentoTemplate
};
